function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_35",
  "data-name": "Path 35",
  d: "M22.7,25.864H5.411A3.161,3.161,0,0,1,2.25,22.7V5.411A3.161,3.161,0,0,1,5.411,2.25H22.7a3.161,3.161,0,0,1,3.161,3.161V22.7A3.161,3.161,0,0,1,22.7,25.864ZM5.411,4.066A1.344,1.344,0,0,0,4.066,5.411V22.7a1.344,1.344,0,0,0,1.344,1.344H22.7A1.344,1.344,0,0,0,24.048,22.7V5.411A1.344,1.344,0,0,0,22.7,4.066Z",
  transform: "translate(-2.25 -2.25)",
  fill: "#023b41"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M3.158,20.1a.92.92,0,0,1-.69-.315A.908.908,0,0,1,2.577,18.5l6.2-5.231a2.422,2.422,0,0,1,3.27.133l2.943,2.943a.605.605,0,0,0,.787,0l2.858-2.071a2.422,2.422,0,0,1,2.955,0l3.936,3.136a.913.913,0,0,1-1.138,1.429l-3.924-3.149a.605.605,0,0,0-.739,0l-2.858,2.216a2.422,2.422,0,0,1-3.161-.218l-2.943-3a.605.605,0,0,0-.811,0L3.739,19.894A.872.872,0,0,1,3.158,20.1Z",
  transform: "translate(-2.25 -0.046)",
  fill: "#023b41"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_37",
  "data-name": "Path 37",
  d: "M15.58,12.91a3.33,3.33,0,1,1,3.33-3.33,3.33,3.33,0,0,1-3.33,3.33Zm0-4.844A1.514,1.514,0,1,0,17.094,9.58,1.514,1.514,0,0,0,15.58,8.066Z",
  transform: "translate(-0.14 -1.406)",
  fill: "#023b41"
});

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "image",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.619,
    height: 23.614,
    viewBox: "0 0 23.619 23.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.351e7b80.svg";
export { ForwardRef as ReactComponent };